import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { LocalStorageService } from '@core/services/local-storage.service';
import { AuthActions } from '@core/store/auth/auth.actions';
import { GlobalActions } from '@core/store/global/global.actions';
import { selectAuth } from '@core/store/auth/auth.selector';
import { isTokenValid } from '@core/utils/auth';
import { Store } from '@ngrx/store';
import { map, skip, take, takeWhile } from 'rxjs';

export const authGuard: CanActivateFn = (_router, state) => {
  const store = inject(Store);
  const router = inject(Router);
  const localStorageService = inject(LocalStorageService);
  const platformId = inject(PLATFORM_ID);
  if (!isPlatformBrowser(platformId)) {
    return false;
  }
  const credential = localStorageService.getAuthToken();
  if (credential && isTokenValid(credential)) {
    if (_router.routeConfig?.path === 'login') {
      return router.createUrlTree(['/']);
    }
    return true;
  } else if (!!credential && credential.refreshToken) {
    store.dispatch(AuthActions.refreshToken());
    return store.select(selectAuth).pipe(
      skip(1),
      takeWhile(
        (authDataRefresh) => !!authDataRefresh.credential?.accessToken
      ),
      take(1),
      map((authDataRefresh) => {
        const hasTokenAccess = !!authDataRefresh.credential?.accessToken;
        if (hasTokenAccess && _router.routeConfig?.path === 'login') {
          return router.createUrlTree(['/']);
        }
        if (!hasTokenAccess) {
          return router.createUrlTree(['/login']);
        }
        return hasTokenAccess;
      })
    );
  }
  if (_router.routeConfig?.path === 'login') {
    return true;
  } else {
    store.dispatch(GlobalActions.setRedirectUrlLoginSuccess(state.url))
    return router.createUrlTree(['/login']);
  }
};
